import { isFunction } from 'lodash';
import { isolateComponent } from '@zapier/style-encapsulation';
import { TextInput as DSTextInput, FormLabel, Typography, Colors, Spacer, } from '@zapier/design-system';
const Styles = {
    details: Object.assign(Object.assign({}, Typography.smallPrint1), { lineHeight: 1.5, color: Colors.neutral700, margin: '5px 0 10px 0', 
        // Override problematic default browser styles.
        'ol, ul': {
            listStylePosition: 'inside',
            margin: 0,
            padding: 0,
        } }),
};
/**
 * A text input form field.
 */
const TextInput = ({ onChange, staticProperties: { details, id, inputType, isMultiline, isRequired, label, placeholder, }, value, }) => {
    return (isolateComponent("div", null,
        isolateComponent(FormLabel, { htmlFor: id, isRequired: isRequired, size: 'small' }, label),
        !details && isolateComponent(Spacer, { height: 5 }),
        details && (isolateComponent("div", { css: Styles.details }, isFunction(details) ? details() : details)),
        isolateComponent(DSTextInput, { ariaRequired: isRequired, id: id, isMultiline: isMultiline, onChange: (evt) => onChange(evt.currentTarget.value), placeholder: placeholder, resize: "vertical", rows: 4, type: inputType, value: value })));
};
export default TextInput;
